import { combineReducers } from "redux";
import Catalogos from "./base.reducer";
import ContenidoCMS from "./cms.reducer";
import ContenidoInterconexion from "./interconexion.reducer";
import Chat from "../../../@Base/components/ChatForm/Store/Reducers/chat-button.reducers"
import User from './user.reducer';
import Token from './cmsAuth.reducer';
import TipoCambio from './tipoCambio.reducer'

const reducer = combineReducers({
  User,
  Token,
  Catalogos,
  ContenidoCMS,
  ContenidoInterconexion,
  Chat,
  TipoCambio
});

export default reducer;
